/**
 * Format hours into a readable string
 * @param hours - Number of hours (can be decimal)
 * @returns Formatted string like "4h 3m" or "30m" or "2h"
 */
export function formatHours(hours: number): string {
    if (hours === 0) return '0h'

    // If less than 1 hour, show only in minutes
    if (hours < 1) {
        const minutes = Math.round(hours * 60)
        return `${minutes}m`
    }

    // If it's a whole number, show without decimals
    if (hours % 1 === 0) {
        return `${hours}h`
    }

    // Show hours and minutes for fractional hours
    const wholeHours = Math.floor(hours)
    const minutes = Math.round((hours - wholeHours) * 60)

    if (minutes === 0) {
        return `${wholeHours}h`
    }

    return `${wholeHours}h ${minutes}m`
}

/**
 * Format seconds into HH:MM:SS format
 * @param seconds - Number of seconds
 * @returns Formatted string like "01:23:45"
 */
export function formatTimeFromSeconds(seconds: number): string {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
}
